export function registrationMailup(){
    (function($) {
        function registrationMailupFunc(e){
            e.preventDefault();
            var email = $('#email').val();
            var name = $('#name').val();
            var lastname = $('#lastname').val();
            var list = $('#interest').val(); // Assicurati che questo sia un campo <select multiple>
            var checkbox = $('#accept_terms');
            var consentTrue = $('#true_consent');
            var termsError = $('#terms-error');

            console.log(list);

            // Nascondi il messaggio di errore inizialmente
            termsError.hide();

            // Verifica se la checkbox è selezionata
            if (!checkbox.is(':checked')) {
                termsError.show(); // Mostra il messaggio di errore
                return; // Esci dalla funzione se la checkbox non è selezionata
            }
            if(!consentTrue.is(':checked')){
                termsError.show(); // Mostra il messaggio di errore
                return; // Esci dalla funzione se la checkbox non è selezionata
            }

            $('.custom_loader').show();
            $('.form_message').hide();
            $('#keep_in_touch_form input[type="submit"]').attr('disabled', true);
            //console.log(email);
            $.ajax({
                url: ajax_posts.ajaxurl,
                type: 'POST',
                data: {
                    action: 'registra_utente_mailup',
                    email: email,
                    name: name,
                    lastname: lastname,
                    list: list,
                    //security: ajax_object.ajax_nonce,
                },
                dataType: 'json',
                success: function(response) {
                    console.log(response);
                    $('.custom_loader').hide();
                    if (response.success) {
                        // Messaggio di successo
                        $('#keep_in_touch_form').hide();
                        $('.form_message:not(.error)').show();
                        //$('.form_message p').text('Registrazione avvenuta con successo! Controlla la tua email per la conferma!');
                    } else {
                        $('.form_message.error').show();
                        //$('.form_message p').text('Si è verificato un errore durante la registrazione. Riprova');
                        $('#keep_in_touch_form input[type="submit"]').attr('disabled', false);
                    }
                },
                error: function(xhr, status, error) {
                    console.error(xhr.responseText);
                    $('.custom_loader').hide();
                    $('.form_message.error').show();
                    $('#keep_in_touch_form input[type="submit"]').attr('disabled', false);
                }
            });
        }

        $('#keep_in_touch_form').on('submit', function(e){
            registrationMailupFunc(e)
        })
    })(jQuery);
}
